import { useState } from "react";

export default function ScriptInsert() {
  const [text, setText] = useState("");

  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };

  return (
    <div className="w-full max-w-2xl mx-auto p-4">
      <div className="relative">
        <textarea
          value={text}
          onChange={handleTextChange}
          placeholder="Enter your script here..."
          className="w-full min-h-[200px] p-4 border border-gray-300 rounded-lg shadow-sm 
                    focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none
                    transition-all duration-200 ease-in-out
                    font-inter text-base leading-relaxed resize-y"
          spellCheck="false"
        />
      </div>
    </div>
  );
}
